// localStorage key 生成工具
// 统一管理所有聊天相关的 localStorage key 生成逻辑

// 基础 key 常量
export const STORAGE_KEYS = {
  // ChatPanel 相关
  CHAT_CONVERSATIONS: 'ai_chat_conversations_v1',
  CHAT_CURRENT_ID: 'ai_chat_current_id_v1',
  CHAT_MODEL: 'ai_chat_model_v1',
  CHAT_KB: 'ai_chat_kb_v1',
  CHAT_SIDEBAR: 'ai_chat_sidebar_v1',
  
  // ChatPanelDifyChatflowApi 相关
  DIFY_CONVERSATIONS: 'dify_chat_conversations_v1',
  DIFY_CURRENT_ID: 'dify_chat_current_id_v1',
  DIFY_SIDEBAR: 'dify_chat_sidebar_v1',
  
  // MobileChatPanelDifyChatflowApi 相关
  MOBILE_DIFY_HISTORY: 'mobile_dify_chat_history_v1',
  MOBILE_DIFY_MESSAGES: 'mobile_dify_chat_messages_v1',
  
  // 其他
  USER_ID: 'user_id',
  CHATPANEL_MODEL_SELECTED: 'chatpanel_model_selected',
  CHATPANEL_KB_SELECTED: 'chatpanel_kb_selected',
};

// 获取用户ID，优先使用真实的用户ID，如果没有则使用本地生成的ID
export const getUserId = (userInfo) => {
  // 检查userInfo是否为有效对象
  if (userInfo && typeof userInfo === 'object') {
    // 优先使用真实的用户ID
    if (userInfo.id) {
      return `user_${userInfo.id}`;
    }
    if (userInfo.username) {
      return `user_${userInfo.username}`;
    }
  }
  
  // 如果没有真实用户信息，使用本地生成的ID
  let userId = localStorage.getItem(STORAGE_KEYS.USER_ID);
  if (!userId || typeof userId !== 'string' || !userId.trim()) {
    userId = 'blooart-' + Math.random().toString(36).slice(2, 12);
    localStorage.setItem(STORAGE_KEYS.USER_ID, userId);
  }
  return userId;
};

// 生成带命名空间的 localStorage 键名
export const getStorageKey = (baseKey, namespace = 'default', agentId = null, userId = null) => {
  if (namespace === 'default' && !agentId && !userId) {
    return baseKey;
  }
  
  let finalNamespace = namespace;
  if (agentId && namespace !== 'default') {
    finalNamespace = `${namespace}_${agentId}`;
  } else if (agentId) {
    finalNamespace = `agent_${agentId}`;
  }
  
  // 添加用户ID到命名空间
  if (userId) {
    finalNamespace = finalNamespace === 'default' ? userId : `${finalNamespace}_${userId}`;
  }
  
  return finalNamespace === 'default' ? baseKey : `${baseKey}_${finalNamespace}`;
};

// ChatPanel 专用的 key 生成函数
export const getChatPanelStorageKey = (baseKey, namespace = 'default', agentId = null, userInfo = null) => {
  const userId = getUserId(userInfo);
  // ChatPanel 不是智能体，如果没有 agentId，只使用 namespace 和 userId
  if (!agentId) {
    return getStorageKey(baseKey, namespace, null, userId);
  }
  return getStorageKey(baseKey, namespace, agentId, userId);
};

// ChatPanelDifyChatflowApi 专用的 key 生成函数
export const getDifyChatStorageKey = (baseKey, namespace = 'default', agentId = null, userInfo = null) => {
  const userId = getUserId(userInfo);
  return getStorageKey(baseKey, namespace, agentId, userId);
};

// MobileChatPanelDifyChatflowApi 专用的 key 生成函数
export const getMobileDifyStorageKey = (namespace, agentId, userInfo = null, suffix) => {
  const userId = getUserId(userInfo);
  return `mobile_chat_${namespace}_${agentId || 'default'}_${userId}_${suffix}`;
};

// 获取用户相关的 key（用于模型选择、知识库选择等）
export const getUserStorageKey = (baseKey, userInfo = null) => {
  const userId = getUserId(userInfo);
  return `${baseKey}_${userId}`;
}; 